import { Category, CategoryFlat, CategoryAnalytics } from 'idt-ecommerce-api/catalog/categories/categories.models';


export class CategoriesHelpers {

  /**
   * Busca una categoría a partir de su identificador de forma recursiva
   * @param categories: Listado de categorías
   * @param categoryId Identificador de una categoría
   */
  public static category(categories: Category[], categoryId: string): Category | undefined {
    for (const category of categories) {
      if (category.id === categoryId) {
        return category;
      }
      const found = CategoriesHelpers.category(category.subcategories, categoryId);
      if (found) {
        return found;
      }
    }
    return undefined;
  }

  /**
   * Devuelve el listado de categorías aplanado en lugar de en modo árbol.
   * @param categories: Listado de categorías, puede ser un nodo concreto del árbol de categorías.
   * @returns Listado de categorías aplanado
   */
  public static flatCategories(categories: Category[]): CategoryFlat[] {
    const flattenCategories = (treeCategory: Category[]) => {
      const seoRegex = /[nl](\d+)($|\?)/;
      return treeCategory.reduce((list: CategoryFlat[], category: Category): CategoryFlat[] => {
        if (category.name.trim()) {
          list.push({
            id: category.id,
            seoId: category.seoId ?? (category.urlSeo ? seoRegex.exec(category.urlSeo)?.[1] : undefined),
            name: category.name,
            key: category.key
          });
        }
        return [
          ...list,
          ...flattenCategories(category.subcategories || [])
        ];
      }, []);
    };

    return flattenCategories(categories);
  }

  /**
   * Devuelve el listado de categorías en un mapa con la id como clave.
   * @param categories: Listado de categorías, puede ser un nodo concreto del árbol de categorías.
   * @returns Mapa con las categorías con su id como clave.
   */
  public static flatCategoriesMap(categories: Category[]): { [key: string]: CategoryAnalytics } {
    const flattenCategoriesMap = (
      treeCategory: Category[],
      flattenedCategories: { [key: string]: CategoryAnalytics },
      path?: string
    ): { [key: string]: CategoryAnalytics } => {
      treeCategory.forEach((category: Category) => {
        const categoryPathEn = path ? `${path}/${category.nameEn}` : category.nameEn;
        flattenedCategories[category.id] = { ...category, sectionPathEn: categoryPathEn };
        flattenedCategories = flattenCategoriesMap(category.subcategories || [], flattenedCategories, categoryPathEn);
      });
      return flattenedCategories;
    };

    return flattenCategoriesMap(categories, {});
  }

  /**
   * Comprueba que categoryId contiene un valor numérico
   * @param categoryId Id de la categoría
   * @returns true si categoryId es un valor numérico, false en otro caso
   */
  public static isValidCategoryId(categoryId?: string): boolean {
    if (!isDefined(categoryId)) {
      return false;
    }
    const numberPattern = /^[0-9]*$/;
    return numberPattern.test(categoryId);
  }

}
